const getLocalizedValue = (value, languageId, languageCode) => {
  if (!value) return ''
  if (typeof value === 'string') return value

  const languageIdKey = languageId ? String(languageId) : ''
  const languageCodeKey = languageCode ? String(languageCode).toLowerCase() : ''
  const shortLanguageCode = languageCodeKey.split('-')[0]

  return (
    value[languageIdKey] ||
    value[languageCodeKey] ||
    value[shortLanguageCode] ||
    value.ja ||
    value.en ||
    ''
  )
}

export const replaceSocialShareRewardAmount = (template, rewardAmount) => {
  if (!template) return ''

  const amount =
    rewardAmount === undefined || rewardAmount === null
      ? ''
      : String(rewardAmount)

  return String(template)
    .replace(/<\s*win\s*amount\s*>/gi, amount)
    .replace(/<\s*winAmount\s*>/g, amount)
    .replace(/<\s*rewardAmount\s*>/gi, amount)
    .replace(/\{\{\s*winAmount\s*\}\}/gi, amount)
    .replace(/\{\{\s*rewardAmount\s*\}\}/gi, amount)
}

export const getConfiguredSocialShareCaption = ({
  campaignConfig,
  rewardAmount,
  languageId,
  languageCode,
}) => {
  const configuredCaption =
    campaignConfig?.socialShare?.caption ||
    campaignConfig?.socialShare?.text ||
    campaignConfig?.social_share?.caption ||
    campaignConfig?.social_share?.text

  const template = getLocalizedValue(configuredCaption, languageId, languageCode)
  return replaceSocialShareRewardAmount(template, rewardAmount)
}

export const buildFallbackCaptionFromTranslator = (t, rewardAmount) =>
  `${t('gamification.sharingContent1') || 'I won ¥'}${rewardAmount}${t('gamification.yen') || ''}${t('gamification.sharingContent2') || ' with the "Tap with Your Phone! Visa Discount Campaign!"'}\n\n${t('gamification.sharingContent3') || 'Anywhere in Japan! As many times a day as you like! Get cashback!'}\n\n${t('gamification.sharingLink') || ''}\n${t('gamification.sharingTags') || '@visajp'} ${t('gamification.sharingHashtags') || '#VisaDiscountCampaign'}`

export const buildFallbackCaptionFromLanguageContent = (
  languageContent,
  rewardAmount,
) => {
  const labels = languageContent?.v3?.gamification || {}

  return `${labels.sharingContent1 || ''}${rewardAmount}${labels.yen || ''}${labels.sharingContent2 || ''}\n\n${labels.sharingContent3 || ''}\n\n${labels.sharingContent4 || ''}${labels.sharingLink || ''}\n${labels.sharingTags || ''} ${labels.sharingHashtags || ''}`.trim()
}
